export function debounce<T extends (...args: any[]) => Promise<void> | void>(
  func: T,
  duration: number
) {
  let timeout: ReturnType<typeof setTimeout> = 0;

  return function (...args: Parameters<T>) {
    const effect = () => {
      timeout = 0;
      return func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  };
}
